exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.table tbody th[data-v-58a9c0a8]:first-child {\n  padding: 0 !important;\n}\n.batch-report-table th[data-v-58a9c0a8] {\n        padding: 0 !important;\n        font-size: .7rem;\n        height: 25px;\n}\n.batch-report-table td[data-v-58a9c0a8] {\n        padding: 0 !important;\n        font-size: .8rem;\n        height: 25px;\n        text-align: center;\n}\n.font-weight-bold[data-v-58a9c0a8] {\n        font-weight: 700;\n}\n", ""]);

// exports
